/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown>, days: NonNullable<unknown> }} Storage_Kept_Versions_ItemInputs */



/**
* | output |
* | --- |
* | "of which {size} are restorable earlier file versions, which expire after {days} days" |
*
* @param {Storage_Kept_Versions_ItemInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const storage_kept_versions_item = /** @type {((inputs: Storage_Kept_Versions_ItemInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storage_Kept_Versions_ItemInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`davon ${i?.size} wiederherstellbare frühere Dateiversionen, verfallen nach ${i?.days} Tagen`)
	return /** @type {LocalizedString} */ (`of which ${i?.size} are restorable earlier file versions, which expire after ${i?.days} days`)
});